export default __webpack_public_path__ + "static/media/logo-psat.37dcc152.svg";